import { BaseEntityWithMultilanguageName } from "./BaseEntity";

export class AnalysisSinkerMaterial extends BaseEntityWithMultilanguageName {
    public static ApiUrl = 'api/analysis-sinker-material';
  }
  